<template>
  <VCard class="detail-delivery-wrapper">
    <VBlock :direction="Direction.column" :padding="[10, 15, 10, 15]">
      <VBlock
        class="item"
        :direction="Direction.column"
        :sort="Sort.left_center"
        :padding="[15, 0, 15, 0]"
      >
        <VSpan class="title" text="배달주소" :size="16" :spacing="-0.38" />
        <VSpan
          class="description"
          :text="orderDetailDelivery.address || ''"
          :size="14"
          :spacing="-0.35"
          :color="TextColor.gray2"
        />
        <VSpan
          class="description"
          :text="`(도로명) ${orderDetailDelivery.roadAddress}` || ''"
          :size="14"
          :spacing="-0.35"
          :color="TextColor.gray2"
        />
      </VBlock>

      <VBlock
        class="item"
        :direction="Direction.column"
        :sort="Sort.left_center"
        :padding="[15, 0, 15, 0]"
      >
        <VSpan class="title" text="전화번호" :size="16" :spacing="-0.38" />
        <VSpan
          class="description"
          :text="orderDetailDelivery.safeMobileNumber || ''"
          :size="14"
          :spacing="-0.35"
          :color="TextColor.gray2"
        />
        <VSpan
          class="description"
          :text="orderDetailDelivery.mobileNumber || ''"
          :size="14"
          :spacing="-0.35"
          :color="TextColor.gray2"
        />
      </VBlock>

      <VBlock
        v-if="!!orderDetailDelivery.userEmail"
        class="item"
        :direction="Direction.column"
        :sort="Sort.left_center"
        :padding="[15, 0, 15, 0]"
      >
        <VSpan class="title" text="주문 내역 발송메일" :size="16" :spacing="-0.38" />
        <VSpan
          class="description"
          :text="orderDetailDelivery.userEmail"
          :size="14"
          :spacing="-0.35"
          :color="TextColor.gray2"
        />
      </VBlock>

      <VBlock
        class="item"
        :direction="Direction.column"
        :sort="Sort.left_center"
        :padding="[15, 0, 15, 0]"
      >
        <VSpan class="title" text="라이더님께" :size="16" :spacing="-0.38" />
        <VP
          class="description"
          :text="orderDetailDelivery.memo || ''"
          :size="14"
          :spacing="-0.35"
          :color="TextColor.gray2"
        />
      </VBlock>
    </VBlock>
  </VCard>
</template>

<script>
import VBullet from '../../atoms/VBullet'
import VBlock, { Direction, Sort } from '../../molecules/VBlock'
import VCard from '../../molecules/VCard'
import VSpan, { TextWeight, TextType, TextColor } from '../../atoms/VSpan'
import VP from '../../atoms/VP'

export default {
  name: 'OrderDetailDelivery',
  components: { VSpan, VBlock, VBullet, VCard, VP },
  props: {
    orderDetailDelivery: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      Direction,
      Sort,
      TextWeight,
      TextType,
      TextColor
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

.detail-delivery-wrapper {
  width: 100%;
  height: auto;
  // border-bottom: 1px solid $light-gray-5;
  margin-bottom: 25px;

  .item {
    width: 100%;
    height: auto;
    box-sizing: border-box;
    border-bottom: 1px solid $light-gray-8;

    &:last-child {
      border-bottom: none;
    }

    .title {
      margin-bottom: 4px;
    }

    .description {
      width: inherit;
      box-sizing: border-box;
      line-break: anywhere;
      text-align: left;
      word-break: break-all;
    }
  }
}
</style>
